'use client';

import { useSearchParams } from 'next/navigation';

import {
  useDeepLinkCustomerType,
  useDeepLinkFulfillmentMethod,
  useDeepLinkStore,
} from '@/hooks';
import { EnumCustomerType } from '@/types';

const DeepLinkStore = () => {
  const query = useSearchParams();
  useDeepLinkStore({ storeName: query?.get('store') as string });
  useDeepLinkCustomerType({
    customerType: query?.get('customerType')?.toUpperCase() as EnumCustomerType,
  });
  useDeepLinkFulfillmentMethod({ method: query?.get('fulfillment') as string });

  return null;
};

export { DeepLinkStore };
